// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_ITEM_DETAIL_REPORT_BUTTON = "Chcem inzer\u00e1t nahl\u00e1si\u0165.";
export const BZ2_ITEM_DETAIL_REPORT_MARK_OK = "Ozna\u010di\u0165 ako OK";
export const BZ2_ITEM_DETAIL_REPORT_MARK_OK_AND_NEXT = "Ozna\u010di\u0165 ako OK a \u00eds\u0165 \u010falej";
export const BZ2_PRODUCT_HAS_COMPLAINTS = "Inzer\u00e1t bol nahl\u00e1sen\u00fd";
export const PRODUCT_REPORT_REPORT_PROBLEM = "Chcem nahl\u00e1si\u0165 probl\u00e9m s obchodom";
